import { attachComponentData } from '@backstage/core-plugin-api';

import {
  PAGE_CONTENT_TABS_KEY,
  type PageContentTabsProps,
} from './composition';

export type { PageContentTabsProps };

export const ContentTabs = (_props: PageContentTabsProps): null => null;

attachComponentData(ContentTabs, PAGE_CONTENT_TABS_KEY, true);
